import { render, staticRenderFns } from "./BannerPreview.vue?vue&type=template&id=44b12504&scoped=true&"
import script from "./BannerPreview.vue?vue&type=script&lang=js&"
export * from "./BannerPreview.vue?vue&type=script&lang=js&"
import style0 from "./BannerPreview.vue?vue&type=style&index=0&id=44b12504&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b12504",
  null
  
)

export default component.exports